/* ============================================================
   c-facet-mode.js
   コレクション/検索サイドバーの「AND / OR モード切替」。

   このストアの商品は絞り込み語彙を custom.scene / custom.feature /
   custom.form（サイドバーの可視枠）と、その統合リスト custom.all で
   持つ（custom.all は Shopify Flow / scripts/sync-kusu-metafield-all.py
   が自動同期）。custom.all の S&D フィルタ枠は有効化のうえ
   c-collection-facets.css で非表示化している。

   Shopify 仕様: 同一フィルタ内の複数値=OR、フィルタ間=AND。
   - AND モード（既定）: チェックボックスは filter.p.m.custom.* のまま
     → メタフィールド枠どうしは AND。
   - OR モード: 可視チェックボックスの name を filter.p.m.custom.all に
     付け替えて送信 → すべて 1 フィルタ扱いになり全 OR。値は統合リストに
     含まれるため流用可能。
   ※タグ(filter.p.tag)を使わないのは、S&D のタグフィルタが翻訳ロケール
     （このストアでは ja。プライマリは en）で機能しないため。

   モード判定/永続化:
   - URL に filter-mode=or があるか、filter.p.m.custom.all が 1 つでもあれば OR。
   - 各フォーム内の hidden input[name="filter-mode"] を OR 時のみ enabled に
     すると、Dawn の FacetFiltersForm が FormData 直列化で URL を作る際に
     モードがラウンドトリップする（Shopify は未知パラメータを無視）。

   facets.js は変更しない。フィルタ絞り込みごとに Dawn が details の
   innerHTML を差し替える（メタフィールド枠は name=filter.p.m.* で再描画
   される）ため、.facets-container を MutationObserver で監視して再変換する。
   ============================================================ */
(function () {
  'use strict';

  var AND_PREFIX = 'filter.p.m.';
  var OR_PARAM = 'filter.p.m.custom.all';
  var LEGACY_TAG_PARAM = 'filter.p.tag';
  var MODE_PARAM = 'filter-mode';
  var OR_CLASS = 'c-facet-mode--or';
  var AND_NAME_ATTR = 'data-c-and-name';
  var MODE_INPUT_ATTR = 'data-c-facet-mode-input';
  var OR_ENABLED_ATTR = 'data-c-or-enabled';

  var applying = false;
  var observers = [];

  function isOrMode() {
    var params = new URLSearchParams(window.location.search);
    return params.get(MODE_PARAM) === 'or' || params.has(OR_PARAM);
  }

  function getContainers() {
    return document.querySelectorAll('.facets-container');
  }

  /* 現在アクティブな OR 条件値の集合。非表示ネイティブ custom.all 枠の checked input
     （＝data-c-and-name を持たない）と URL の filter.p.m.custom.all から得る。 */
  function activeOrValues() {
    var set = {};
    document.querySelectorAll('input[name="' + OR_PARAM + '"]:checked').forEach(function (input) {
      if (!input.hasAttribute(AND_NAME_ATTR)) set[input.value] = true;
    });
    new URLSearchParams(window.location.search).getAll(OR_PARAM).forEach(function (value) {
      set[value] = true;
    });
    return set;
  }

  /* 可視メタフィールドチェックボックス（未変換 name^=filter.p.m. と 変換済み）。
     ネイティブ custom.all 枠の input は name が OR_PARAM かつ未変換なので除外する */
  function metafieldCheckboxes(root) {
    return root.querySelectorAll(
      'input[type="checkbox"][name^="' + AND_PREFIX + '"]:not([name="' + OR_PARAM + '"]),'
        + ' input[type="checkbox"][' + AND_NAME_ATTR + ']'
    );
  }

  function toOrMode(root) {
    var actives = activeOrValues();

    metafieldCheckboxes(root).forEach(function (input) {
      // 元の name（メタフィールド param）を退避して name を filter.p.m.custom.all に
      if (!input.hasAttribute(AND_NAME_ATTR)) {
        input.setAttribute(AND_NAME_ATTR, input.getAttribute('name'));
      }
      if (input.getAttribute('name') !== OR_PARAM) input.setAttribute('name', OR_PARAM);

      // アクティブな OR 条件値に checked を同期
      var shouldCheck = actives[input.value] === true;
      if (input.checked !== shouldCheck) input.checked = shouldCheck;

      // AND では count==0 で disabled のものも OR では選択可にする
      if (input.disabled) {
        input.disabled = false;
        input.setAttribute(OR_ENABLED_ATTR, 'true');
      }
      var label = input.closest('.facets__label');
      if (label && label.classList.contains('disabled')) {
        label.classList.remove('disabled');
        label.setAttribute(OR_ENABLED_ATTR, 'true');
      }
    });

    // 非表示ネイティブ custom.all 枠の input を無効化（序列化されると解除できなくなるため）
    root.querySelectorAll('input[name="' + OR_PARAM + '"]').forEach(function (input) {
      if (!input.hasAttribute(AND_NAME_ATTR) && !input.disabled) input.disabled = true;
    });

    // hidden filter-mode を有効化（filter-mode=or をラウンドトリップさせる）
    root.querySelectorAll('input[' + MODE_INPUT_ATTR + ']').forEach(function (input) {
      if (input.disabled) input.disabled = false;
    });

    if (!root.classList.contains(OR_CLASS)) root.classList.add(OR_CLASS);
    updateButtons(root, true);
  }

  function toAndMode(root) {
    // AND ではサーバーレンダリングのまま。UI 整合だけ取る。
    root.querySelectorAll('input[' + MODE_INPUT_ATTR + ']').forEach(function (input) {
      if (!input.disabled) input.disabled = true;
    });
    if (root.classList.contains(OR_CLASS)) root.classList.remove(OR_CLASS);
    updateButtons(root, false);
  }

  function updateButtons(root, orMode) {
    root.querySelectorAll('[data-c-facet-mode]').forEach(function (btn) {
      var btnIsOr = btn.getAttribute('data-c-facet-mode') === 'or';
      btn.setAttribute('aria-pressed', btnIsOr === orMode ? 'true' : 'false');
    });
  }

  /* applyMode: 自前の変更は attribute / checked プロパティのみで childList を
     変えないため、childList 監視の MutationObserver を再発火させない。
     加えて applying ガードと「変換済みならスキップ」で二重適用を避ける。 */
  function applyMode() {
    if (applying) return;
    applying = true;
    try {
      var orMode = isOrMode();
      getContainers().forEach(function (root) {
        if (orMode) toOrMode(root);
        else toAndMode(root);
      });
    } finally {
      applying = false;
    }
  }

  /* 現在チェック中の可視メタフィールドチェックボックスを収集（value+元param で重複排除）。
     デスクトップ枠とモバイル枠は同じ値を二重に持つため必ず排除する。 */
  function collectSelections() {
    var seen = {};
    var selections = [];
    document.querySelectorAll('.facets-container input[type="checkbox"]:checked').forEach(function (cb) {
      var andName = null;
      if (cb.hasAttribute(AND_NAME_ATTR)) {
        andName = cb.getAttribute(AND_NAME_ATTR);
      } else if (cb.name === OR_PARAM) {
        return; // ネイティブ custom.all 枠は対象外
      } else if (cb.name && cb.name.indexOf(AND_PREFIX) === 0) {
        andName = cb.name;
      } else {
        return; // 価格・在庫などは対象外
      }
      var key = andName + '|' + cb.value;
      if (seen[key]) return;
      seen[key] = true;
      selections.push({ value: cb.value, andName: andName });
    });
    return selections;
  }

  /* モード切替。チェックボックス操作と同じ Dawn の AJAX 再描画
     (FacetFiltersForm.renderPage) を使う。updateURLHash が同期的に
     pushState するため、直後の applyMode で切替ボタン表示も即時反映できる。
     facets.js 未ロード時のみフル遷移にフォールバック。 */
  function switchMode(targetOr) {
    var selections = collectSelections();
    var params = new URLSearchParams(window.location.search);

    Array.from(params.keys()).forEach(function (key) {
      if (key.indexOf(AND_PREFIX) === 0 || key === LEGACY_TAG_PARAM || key === MODE_PARAM || key === 'page') {
        params.delete(key);
      }
    });

    if (targetOr) {
      selections.forEach(function (s) {
        params.append(OR_PARAM, s.value);
      });
      params.set(MODE_PARAM, 'or');
    } else {
      selections.forEach(function (s) {
        params.append(s.andName, s.value);
      });
    }

    var qs = params.toString();

    if (typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.renderPage === 'function') {
      FacetFiltersForm.renderPage(qs, null, true);
      applyMode();
    } else {
      window.location.assign(window.location.pathname + (qs ? '?' + qs : ''));
    }
  }

  function onDocumentClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var btn = target.closest('[data-c-facet-mode]');
    if (!btn) return;
    event.preventDefault();
    var wantOr = btn.getAttribute('data-c-facet-mode') === 'or';
    if (wantOr === isOrMode()) return; // 既に同モード
    switchMode(wantOr);
  }

  function observe() {
    observers.forEach(function (o) {
      o.disconnect();
    });
    observers = [];
    getContainers().forEach(function (root) {
      var mo = new MutationObserver(function () {
        if (applying) return;
        applyMode();
      });
      mo.observe(root, { childList: true, subtree: true });
      observers.push(mo);
    });
  }

  function init() {
    applyMode();
    observe();
  }

  // click はイベント委譲（再描画でリスナーが消えない）
  document.addEventListener('click', onDocumentClick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();
